import * as React from "react";
import { TextField, MenuItem, styled } from "@mui/material";

interface Props {
    items: { key: string; value: string }[];
    selectedKey: string;
    onChangeSelected: (key: string) => void;
    size?: "small" | "medium";
}

export default function DropdownSelector({ onChangeSelected, items, selectedKey, size }: Props) {
    const smallCss = {
        "& .MuiOutlinedInput-input": {
            padding: "8px 30px 8px 10px",
            fontSize: "14px",
            minWidth: "80px",
            width: "100%",
            backgroundColor: "white",
        },
    };

    const CssTextField = styled(TextField)(size === "small" ? smallCss : { backgroundColor: "white" });
    const smallSizeText =
        size === "small" ? { fontSize: "14px", backgroundColor: "white" } : { backgroundColor: "white" };

    return (
        <CssTextField
            select
            name="region"
            onChange={(e: any) => onChangeSelected(e.target.value)}
            variant="outlined"
            value={selectedKey}
            fullWidth
        >
            {items.map((item) => (
                <MenuItem value={item.key} key={item.key} selected={item.key === selectedKey} style={smallSizeText}>
                    {item.value}
                </MenuItem>
            ))}
        </CssTextField>
    );
}
